module.exports = __webpack_public_path__ + "static/babel-d255e75f6f38e21bc5b17f296248339c.svg";